export var ButtonStyleTypes;

(function (ButtonStyleTypes) {
  ButtonStyleTypes["Destructive"] = "Destructive";
  ButtonStyleTypes["Naked"] = "Naked";
  ButtonStyleTypes["Neutral"] = "Neutral";
  ButtonStyleTypes["Primary"] = "Primary";
})(ButtonStyleTypes || (ButtonStyleTypes = {}));